const DAYS = 'Sun,Mon,Tue,Wed,Thu,Fri,Sat'.split(',');
const MONTHS = 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec'.split(',');

type Options = {
  /**
   * Set `fromUTC` to true only if the incoming date is encoded as UTC but
   * actually represents a specific local time somewhere in the world. Likely
   * the only situation you should use this is for market dates, because they
   * should NOT be adjusted for the timezone of the viewer. For example, if I'm
   * viewing a California market from Asia, I shouldn't see the market dates
   * adjusted for my local timezone since the market will NOT take place in my
   * local timezone, it will take place in California.
   */
  fromUTC?: boolean;
  /** Include the day of week in the output, e.g. "Sun, 3 Jan 2021" */
  includeDayOfWeek?: boolean;
};

/** Displays date like "3 Jan 2021" by default. */
export default function formatDate(
  d: number | string | Date,
  options: Options = {},
): string {
  let { fromUTC, includeDayOfWeek } = options;
  let date: Date;
  if (d instanceof Date) {
    date = d;
  } else {
    let ms = typeof d === 'number' ? d : Date.parse(d);
    date = ms ? new Date(ms) : new Date(0);
  }
  let dayOfWeek = fromUTC ? DAYS[date.getUTCDay()] : DAYS[date.getDay()];
  let day = fromUTC ? date.getUTCDate() : date.getDate();
  let month = fromUTC ? date.getUTCMonth() : date.getMonth();
  let year = fromUTC ? date.getUTCFullYear() : date.getFullYear();
  let shortMonthName = MONTHS[month] ?? '';
  return `${
    includeDayOfWeek ? `${dayOfWeek}, ` : ''
  }${day} ${shortMonthName} ${year}`;
}
